(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
